<div class="dl-tabs">
    <div class="dl-tabs__item"
         *ngFor="let item of list"
         [class.active]="item === (activeItem$ | async)"
         (click)="setActiveTab(item)"
    >
        <span class="dl-tabs__btn">
             {{'app.tabs.' + item | translate}}
        </span>
    </div>
</div>
